module.exports = __webpack_public_path__ + "static/media/resume2020.91a54da3.pdf";